import isEmpty from "../lib/isEmpty";
import { ServiceFeeaction } from "./v1/report";
import config from "../lib/config";
import { get_domain, get_types } from "../views/hooks/useParamsforSign";
import { ethers, solidityPackedKeccak256 } from "ethers";
import { toast } from "react-toastify";

export const GetGasFees = async (data) => {
  try {
    var { web3, encoded, contractaddress, value, accountAddress } = data;
    var gasPrice = await web3.eth.getGasPrice();
    
    var gasdata;
    if (value) {
      gasdata = await web3.eth.estimateGas({
        from: accountAddress,
        to: contractaddress,
        value: value,
        data: encoded,
      });
    } else {
      gasdata = await web3.eth.estimateGas({
        from: accountAddress,
        to: contractaddress,
        data: encoded,
      });
    }

    
    return { gasdata: gasdata, gasPrice: gasPrice };
  }
  catch (err) {
    console.error("errorrr", err);
    return undefined;
  }
};

export const NewGetGasFees = async (data) => {
  try {
    var { web3, contractcall, value, accountAddress } = data;
    var gasPrice = await web3.eth.getGasPrice();
    
    var gasdata;
    if (value) {
      
      gasdata = await contractcall.estimateGas({
        from: accountAddress,
        value: value,
      });
    } else {
      gasdata = await contractcall.estimateGas({
        from: accountAddress,
      });
    }

    
    return { gasdata: gasdata, gasPrice: gasPrice };
  } catch (err) {
    console.error("NewGetGasFees errorrr", err, data);
    return { gasdata: 29094, gasPrice: 5000000000 };
  }
};

export const GetServiceFee = async (type, Contract) => {
  let Resp = await ServiceFeeaction({ type: "get" });
  
  let currfees = Resp?.data?.filter((val) => val.FeeName == type).pop();
  if (isEmpty(currfees?.key) && currfees?.key != 0) {
    currfees = {};
    currfees.key = config?.defaultservicekey;
  }
  let fees = await Contract.methods.FeeType(currfees?.key).call();
  
  return {
    key: currfees.key,
    Service_Fee_buyer: fees?.buyerFees,
    Service_Fee_seller: fees?.sellerFees,
    Minting_fee: fees?.mintFees,
    Listing_fee: fees?.listFees,
    Withdraw_fee: fees?.withdrawFees,
  };
};

export const generateSalt = async (web3, address) => {
  const provider = web3;
  const ethersProvider = new ethers.BrowserProvider(provider);
  const nonce = await ethersProvider.getTransactionCount(address);
  
  const hash = solidityPackedKeccak256(
    ["string", "address", "uint256"],
    [config.SIGNING_SALT_KEY, address, nonce]
  );
  return { hash, nonce };
};

export const sign_typed_data = async (web3, ...data) => {
  try {
    const provider = web3;
    const ethersProvider = new ethers.BrowserProvider(provider);
    console.log("🚀 ~ constsign_typed_data= ~ ethersProvider:", ethersProvider)
    const signer = await ethersProvider.getSigner();
    console.log("🚀 ~ constsign_typed_data= ~ signer:", signer)
    const getHash = await signer.signTypedData(...data);
    console.log("🚀 ~ constsign_typed_data= ~ getHash:", getHash)
    return getHash;
  } catch (error) {
    console.error("err on signTypedData", error);
    // toast.error(error.toString(),config.toasterOption);
    return false;
  }
};

export const signMessage = async (
  web3,
  address,
  type,
  data,
  CHAIN_ID,
  contractAddress
) => {
  try{
    const deadline = new Date().setMinutes(new Date().getMinutes() + 5);
    const genSalt = await generateSalt(web3, address);
    console.log("🚀 ~ genSalt:", genSalt)
    const message = { ...data, deadline, salt: genSalt.hash };
    const domain = get_domain(type, CHAIN_ID, contractAddress);
    console.log("🚀 ~ domain:", domain)
    console.log("🚀 ~ message:", message)
    
    const types = get_types?.[type];
    console.log("🚀 ~ types:", types)
    
    const getSign = await sign_typed_data(web3, domain, types, message);
    console.log("🚀 ~ getSign:", getSign)
    
    if(!getSign){
      return { hash : false , err : "Try Again..."}
    }
    return { hash: getSign, nonce: genSalt.nonce, deadline, salt: genSalt.hash };
  }catch(err){
    console.error("🚀 ~ signMessage_error:", err)
    return { hash : false , err : "Try Again..."}
  }
 
};
